import { render, staticRenderFns } from "./PricingBanner.vue?vue&type=template&id=1b648b72&scoped=true&"
import script from "./PricingBanner.vue?vue&type=script&lang=js&"
export * from "./PricingBanner.vue?vue&type=script&lang=js&"
import style0 from "./PricingBanner.vue?vue&type=style&index=0&id=1b648b72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b648b72",
  null
  
)

export default component.exports